import React from "react";
import PropTypes from "prop-types";
import { Grid, Checkbox } from "@mui/material";

const ConsentSummary = ({ assignedConsents }) => {
  return (
    <Grid container spacing={1} pt="1" sx={{ fontSize: "14px" }}>
      {assignedConsents.map((consent, index) => (
        <Grid item key={index} xs={6} sm={4}>
          <Checkbox checked={true} value="1" disabled={true} sx={{ pl: 0 }} />
          <span>{consent.name}</span>
        </Grid>
      ))}
    </Grid>
  );
};

ConsentSummary.propTypes = {
  assignedConsents: PropTypes.array.isRequired
};

export default ConsentSummary;
